var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.4121353 2.12310641 5.74948744 4.13477936 7 8 C7.51555338 11.9525759 7.15914688 13.7044415 5.25 17.25 C2.2772789 20.88332579 0.72224085 21.77535989 -3.875 22.375 C-7.87153796 21.89541545 -9.90459308 20.53260567 -13 18 C-15.35242347 14.79214982 -15.4684209 11.90350748 -15 8 C-13.36564595 4.96477105 -11.944447 2.71647703 -9.1875 0.625 C-5.94376185 -0.30178233 -3.35738508 -0.35340896 0 0 Z M-9.375 5.625 C-11.48706506 8.71186432 -11.61195145 10.3282913 -11 14 C-9.5 16.5 -9.5 16.5 -7 18 C-3.3282913 18.61195145 -1.71186432 18.48706506 1.375 16.375 C3.48706506 13.28813568 3.61195145 11.6717087 3 8 C1.5 5.5 1.5 5.5 -1 4 C-4.6717087 3.38804855 -6.28813568 3.51293494 -9.375 5.625 Z ",
    fill: "#7F7E97",
    transform: "translate(24,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.22189876 2.3574869 5.37061713 4.52270855 7.5625 7.875 C7.875 11.75 7.875 11.75 7.5625 14.875 C6.5725 14.875 5.5825 14.875 4.5625 14.875 C4.26859375 13.95267578 4.26859375 13.95267578 3.96875 13.01171875 C2.23443494 8.20096003 2.23443494 8.20096003 -1.203125 4.57421875 C-7.12981473 2.1125425 -12.28537951 2.68419893 -18.25 4.9375 C-21.48050458 7.79880405 -22.16208267 10.78023909 -23.4375 14.875 C-24.4275 14.875 -25.4175 14.875 -26.4375 14.875 C-26.85019478 11.50465931 -27.05357781 8.91216803 -25.27734375 5.921875 C-18.77240728 -1.9971781 -9.61649113 -3.14721528 0 0 Z ",
    fill: "#7F7E97",
    transform: "translate(29.4375,25.125)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUser);
export default __webpack_public_path__ + "static/media/menu_user.c64289101b13a207bb0b87cb3608cee2.svg";
export { ForwardRef as ReactComponent };